// One build-time origin for Rails browser endpoints. Assets stay on the game origin.
const env = import.meta.env || {}
export function normalizeApiOrigin(value = '') {
  if (!String(value).trim()) return ''
  const url = new URL(String(value).trim())
  const local = ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname)
  if ((url.protocol !== 'https:' && !(local && url.protocol === 'http:')) || url.username || url.password || !['', '/'].includes(url.pathname) || url.search || url.hash) {
    throw new Error('VITE_API_ORIGIN must be an HTTPS origin without credentials, a path, query or fragment (HTTP loopback is allowed for development).')
  }
  return url.origin
}
export const API_ORIGIN = normalizeApiOrigin(env.VITE_API_ORIGIN)
const apiPath = /^\/(?:api\/(?:player|v1)(?:\/|[?#]|$)|(?:plan|tts|voices)(?:[?#]|$))/
export function apiUrl(path, origin = API_ORIGIN) {
  const base = normalizeApiOrigin(origin)
  const value = String(path)
  return base && apiPath.test(value) ? base + value : value
}
export function apiCredentials(url, origin = API_ORIGIN) {
  const base = normalizeApiOrigin(origin)
  if (!base) return 'same-origin'
  try { return new URL(url, globalThis.location?.href || 'http://localhost').origin === base ? 'include' : 'same-origin' }
  catch { return 'same-origin' }
}
export function isApiOrigin(origin, configured = API_ORIGIN) {
  return !!configured && origin === normalizeApiOrigin(configured)
}

// A picture drawn into a canvas (Quest windows, the XR HUD) loads with CORS:
// another host's picture taints the canvas, and WebGL and XR layers refuse a
// tainted one ("Tainted canvases may not be loaded"), so the window stops
// updating. The API host's pictures go with the cookie (draft covers are the
// owner's only) and under an address of their own: the web pages show the same
// pictures without CORS, and a CORS load of that address is answered from the
// copy the browser kept then, which has no CORS header, so it fails.
export function canvasPicture(url, origin = API_ORIGIN) {
  const base = normalizeApiOrigin(origin)
  try {
    const address = new URL(url, globalThis.location?.href || 'http://localhost')
    if (base && address.origin === base) {
      address.searchParams.set('cors', '1')
      return { src: address.href, crossOrigin: 'use-credentials' }
    }
  } catch {}
  return { src: url, crossOrigin: 'anonymous' }
}

// Navigation to Rails HTML pages must use the API cookie host too.
export function accountUrl(path, origin = API_ORIGIN) {
  const base = normalizeApiOrigin(origin)
  return base && /^\/(?:account|players|shared-saves)(?:\/|[?#]|$)/.test(String(path)) ? base + path : path
}
